/**
 * 统一从 axios 错误对象提取 message 的小帮手 — 替代各处重复的
 * `err?.response?.data?.message ?? err?.message ?? '操作失败'`。
 *
 * 调用：`toast.error(errMsg(err, '推进失败'))`
 */
export function errMsg(e: unknown, fallback = '操作失败'): string {
  const anyE = e as any;
  return (
    anyE?.response?.data?.message ??
    anyE?.message ??
    fallback
  );
}
